import React from "react";
import ErrorPage from "./_error.page";
import { ExtendedNextPage } from "components/common/types";

const NotFoundPage: ExtendedNextPage<Record<string, unknown>> = () => {
  return <ErrorPage statusCode={404} />;
};

NotFoundPage.disableDataProviders = true;

export default NotFoundPage;
